import { format } from 'date-fns'

type NumberFormatOptionsStyle = 'decimal' | 'percent'

export const formatNumber = (
  value: number | undefined,
  style: NumberFormatOptionsStyle = 'decimal',
) => (value === undefined ? '' : Intl.NumberFormat('de-DE', { style }).format(value))

export const formatCurrency = (
  value: number | undefined,
  options?: { currency?: string; fractionDigits?: number; locale?: Intl.LocalesArgument },
) =>
  value === undefined
    ? ''
    : Intl.NumberFormat(options?.locale ?? 'de-DE', {
        style: 'currency',
        currency: options?.currency ?? 'EUR',
        minimumFractionDigits: options?.fractionDigits,
        maximumFractionDigits: options?.fractionDigits,
      }).format(value)

export const formatDate = (date: Date, formatStr = 'MMM dd') => format(date, formatStr)

export const formatDateTime = (date: Date, formatStr = 'MMM dd, HH:mm a') => format(date, formatStr)
